import * as React from "react";
import {notifyBugsnagAndShowToast} from "../../../../utils/Utils";
import Routes from "../../../../navigation/route/Route";
import {Option} from "ts-option";
import Job from "../../../../model/job/Job";
import {connect, Dispatch} from "react-redux";
import {OnFailure, OnSuccess, OnSuccessData} from "../../../../store/action/actionHelpers";
import {fetchJobByRefNumber} from "../../../../store/action/job/job";
import {RootState} from "../../../../store/reducer/root/RootState";
import {getJobByIdOrRefNumber} from "../../../../store/view/job";
import {RouteComponentProps, withRouter} from "react-router";
import Loading from "../../../ui/loading/Loading";
import Toast from "../../../helper/Toast";
import {getBillOfMaterialsByJobId} from "../../../../store/view/bom";
import {fetchBillOfMaterialsByJobId} from "../../../../store/action/billOfMaterials/billOfMaterials";
import BillOfMaterialDetails from "./BillOfMaterialDetails";
import {Bom} from "../../../../model/job/Bom";

interface RouteProps {
	/**
	 * Job reference number.
	 */
	jobReferenceNumber: string;
}

interface State {
	/**
	 * Job fetching in progress
	 */
	jobFetching: boolean;
	/**
	 * Job fetched flag
	 */
	jobFetched: boolean;
}

interface DispatchProps {
	/**
	 * Fetch job
	 * @param {string} jobRefNumber
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	fetchJobByRefNumber: (jobRefNumber: string, onSuccess: OnSuccess, onFailure: OnFailure) => void;
	/**
	 * Fetch Bill Of Materials details
	 * @param {string} jobId
	 * @param {OnSuccess} onSuccess
	 * @param {OnFailure} onFailure
	 */
	fetchBillOfMaterialsByJobId: (jobId: string,
		onSuccess: OnSuccessData<Bom>,
		onFailure: OnFailure) => void;
}

interface ReduxProps {
	/**
	 * Job
	 */
	job: Option<Job>
	/**
	 * Bill Of Materials Details
	 */
	bomDetails: Option<Bom>
}

type Props = ReduxProps & DispatchProps & RouteComponentProps<RouteProps>;

class JobBillOfMaterialsDetails extends React.PureComponent<Props, State> {
	constructor(props: Props) {
		super(props);
		this.state = {jobFetching: false, jobFetched: false}
	}

	componentDidMount(): void {
		this.props.job.map(j => {
			this.checkJobData(j);
		});
		this.checkJobExists();
		this.fetchData(this.props.job);
	}

	componentWillReceiveProps(nextProps: Props) {
		if (this.props.job.map(j => j.id).orNull !== nextProps.job.map(j => j.id).orNull) {
			nextProps.job.map(j => {
				this.checkJobData(j);
				this.fetchData(nextProps.job);
			});
		}
		if (this.props.job.isDefined && nextProps.job.isEmpty) {
			this.setState({jobFetched: false, jobFetching: false});
		}

		this.checkJobExists(nextProps.job);
	}

	render() {
		return (
			<div className={"l-page"}>
				<Loading isLoading={this.props.job.isEmpty || this.props.bomDetails.isEmpty}>
					{this.props.job.flatMap(j => this.props.bomDetails.map(
						bom => <BillOfMaterialDetails job={j}
													  bom={bom}
													  redirectToJob={this.redirectToJob}
													  isBomDefinedForJob/>)).orNull}
				</Loading>
			</div>
		);
	}

	checkJobExists(job = this.props.job) {
		if (job.isEmpty) {
			if (this.state.jobFetched) {
				return;
			}
			else if (!this.state.jobFetching) {
				this.setState({jobFetching: true},
					() => this.props.fetchJobByRefNumber(
						this.props.match.params.jobReferenceNumber,
						() => {this.setState({jobFetched: true, jobFetching: false})},
						(err) => {
							notifyBugsnagAndShowToast(err, "Fetch job");
							this.navigateToJobsList();
						}
					)
				);
			}
		}
	}

	/**
	 * If job data is not complete or bom is not allowed for this job, redirects to job details
	 * @param job
	 */
	checkJobData = (job: Job) => {
		if (!job.data.allowBom) {
			this.redirectToJob();
			return
		}
		if (job.quoteId.isEmpty) {
			Toast.error("Quote is required", "Bill of materials");
			this.redirectToJob();
		}
	};

	navigateToJobsList = () => this.props.history.push(Routes.JobsList);

	redirectToJob = () => this.props.history.push(Routes.EditJob(this.props.match.params.jobReferenceNumber));

	fetchData(job: Option<Job>) {
		job.map(j => {
			if (this.props.bomDetails.isEmpty) {
				this.props.fetchBillOfMaterialsByJobId(j.id,
					() => {},
					(err) => {
						notifyBugsnagAndShowToast(err, "Job bill of materials details",
							"Cannot fetch job bill of materials details");
						this.redirectToJob()
					}
				)
			}
		});
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchJobByRefNumber: (jobRefNumber: string, onSuccess: OnSuccess, onFailure: OnFailure) => dispatch(
			fetchJobByRefNumber(jobRefNumber, onSuccess, onFailure)),
		fetchBillOfMaterialsByJobId: (jobId: string,
			onSuccess: OnSuccessData<Bom>,
			onFailure: OnFailure) => dispatch(
			fetchBillOfMaterialsByJobId(jobId, onSuccess, onFailure))
	}
}

function mapStateToProps(state: RootState, props: Props) {
	const job = getJobByIdOrRefNumber(props.match.params.jobReferenceNumber, state);
	const jobId = job.map(j => j.id).orNull;
	const bomDetails = getBillOfMaterialsByJobId(jobId, state);
	return {job, bomDetails};
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(JobBillOfMaterialsDetails))
